/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  
  const currencyCountries = [
    {code: 'GBP', country: 'United Kingdom'},
    {code: 'EUR', country: 'Europe'},
    {code: 'USD', country: 'United States'},
    {code: 'CAD', country: 'Canada'},
    {code: 'AUD', country: 'Australia'},
    {code: 'NZD', country: 'New Zealand'},
    {code: 'JPY', country: 'Japan'},
    {code: 'SGD', country: 'Singapore'},
    {code: 'HKD', country: 'Hong Kong'},
  ];
    
    document.querySelector('#localization_form_header .tooglearrow').onclick = (event) => {
    console.log("event", event);
    let button = document.querySelector('#localization_form_header .dropdown-arrow');
  	button.click();
  }
    
    const button = document.querySelector('button');
    
  document.querySelector('button[aria-controls="header-currency-popover"]').onclick = (event) => {
    console.log("event", event);
    let button = document.querySelector('button[aria-controls="header-currency-popover"]');
  	button.ariaExpanded = !JSON.parse(button.ariaExpanded);
    let pop = document.querySelector('#header-currency-popover');
  	pop.ariaHidden = !JSON.parse(pop.ariaHidden);
  }

    document.querySelectorAll('button.Popover__Value[name="currency_code"]').forEach(currencyCodeInput => {
      const currentCode = currencyCodeInput.value;
      let currentCountry, currentCountryIndex;
      for (let i = 0; i < currencyCountries.length; i++){
        if (currencyCountries[i].code === currentCode){
          currentCountry = currencyCountries[i];
          currentCountryIndex = i;
          break;
        }
      }
      if (currentCountry){
 		currencyCodeInput.style.order = currentCountryIndex;
 		currencyCodeInput.innerHTML = '<span>'+currentCountry.country+'</span> ('+currentCountry.code+')';
      }
    
    });

    document.querySelectorAll('button.Collapsible__Currency').forEach(currencyCodeInput => {
      const currentCode = currencyCodeInput.value;
      let currentCountry, currentCountryIndex;
      for (let i = 0; i < currencyCountries.length; i++){
        if (currencyCountries[i].code === currentCode){
          currentCountry = currencyCountries[i];
          currentCountryIndex = i;
          break;
        }
      }
      if (currentCountry){
 		currencyCodeInput.parentElement.style.order = currentCountryIndex;
        for (const nodeItem of currencyCodeInput.childNodes){
          if (nodeItem.nodeType === 3){
            nodeItem.nodeValue = currentCountry.country+' ('+currentCountry.code+')';
            break;
          }
        }
      }
    
    });
    
})();

(function() {
  const show_cookie_prompt = getCookie('show_cookie_prompt');
  if (!show_cookie_prompt || show_cookie_prompt == 'true'){
    const cookiePopup = document.querySelector('div#shopify-section-cookie-consent .cookie-popup');
    const cookieAgree = document.querySelector('button.cookie-agree-button');
    const cookieThanks = document.querySelector('button.no_thanks_cookie-agree-button');
    const cookieAgreebtn = document.querySelector('button.agree_cookie-agree-button');
    if (cookiePopup && cookieAgree && cookieThanks && cookieAgreebtn ){
      cookiePopup.style.display = '';
      cookieAgree.onclick = function(event){
        setCookie('show_cookie_prompt', 'false', 999999);
          cookiePopup.style.display = 'none';
      },

      cookieThanks.onclick = function(event){
        setCookie('show_cookie_prompt', 'false', 999999);
          cookiePopup.style.display = 'none';
      },

        cookieAgreebtn.onclick = function(event){
        setCookie('show_cookie_prompt', 'false', 999999);
          cookiePopup.style.display = 'none';
      }
    }
  }
  
  function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }
  function removeCookie(name) {   
    document.cookie = name+'=; expires = Thu, 01 Jan 1970 00:00:00 GMT'; 
  }
    
})();

// if (location.hash == "#tiktok"){
//  document.querySelector('.product-tiktok-section').style.display = ''; 
// }

(function() {
  document.addEventListener('DOMContentLoaded', function(event) {
        
    const hideCartButtons = document.querySelectorAll('.js-menuToggle, .js-searchToggle');
    hideCartButtons.forEach(button => {
      button.onclick = function(event){
		const cartOpen = document.querySelector('.cartToggle[aria-expanded="true"]');
        if (cartOpen){
          document.querySelector('.js-cartToggle-close').click();
          setTimeout(function(){
          	button.click();  
          }, 500);
        }
      }
    });
    
    const productPageBadge = document.querySelector('.product-title-container .product__badge');
    const reviewsSection = document.getElementById('shopify-product-reviews');
    if (productPageBadge && reviewsSection){
      productPageBadge.onclick = function(e){
        const y = reviewsSection.getBoundingClientRect().top + window.scrollY;
        window.scroll({
          top: y-100,
          behavior: 'smooth'
        });
      }
    }
    
    if (!Shopify.country == 'GB'){
     document.querySelector('body').classList.add('international');
    }
    
  });
})();

const urlParams = new URLSearchParams(window.location.search);
const addProduct = urlParams.get('add_product');
if (addProduct){
	fetch('/cart/add.js', {
	  method: 'POST', // or 'PUT'
	  headers: {
	    'Content-Type': 'application/json',
	  },
	  body: JSON.stringify({
	    items: [{
	        id: addProduct,
	        quantity: 1
	    }]
	  }),
	})
    .then(response => response.json())
    .then(cart => {
      const product = cart.items.find(item => item.itemVariantId == addProduct);
		window.history.replaceState(null, null, window.location.pathname);
      Cart.getCart(Cart.buildCart);

      if ($(window).width() >= 550){
        Cart.popover.show(product);
      }
    });
}

(function() {
  document.addEventListener('DOMContentLoaded', function(event) {
	const copyCodeButton = document.querySelector('.product-copy-code-button');
    if (copyCodeButton){
      copyCodeButton.onclick = function(event){
        const code = document.querySelector('.product-copy-code-input');
        if (code){
          code.select();
          code.setSelectionRange(0, 99999); /* For mobile devices */
          navigator.clipboard.writeText(code.value);
          document.querySelector('.product-copy-code-button').style.width = document.querySelector('.product-copy-code-button').offsetWidth+'px';
          copyCodeButton.innerText = "Copied!";
          setTimeout(function(){
            copyCodeButton.innerText = "Copy Code";
            document.querySelector('.product-copy-code-button').style.width = '';
          }, 1000);
        }
      };
    }
  });
})();

function cloneAttributes(target, source) {
  [...source.attributes].forEach( attr => { target.setAttribute(attr.nodeName ,attr.nodeValue) })
}

function cartAddToCart(event){
  console.log(event.target);
  const cartAddToCartContainer = document.querySelector('.cart-add-to-cart-form');
  const pseudoForm = event.target.parentElement.cloneNode(true);
  cartAddToCartContainer.appendChild(pseudoForm);
  var newForm = document.createElement('form');
  newForm.innerHTML = pseudoForm.innerHTML;
  cloneAttributes(newForm, pseudoForm);
  pseudoForm.parentNode.replaceChild(newForm, pseudoForm);
  const submitButton = newForm.querySelector('button');
  submitButton.classList.add('js-productForm-submit');
  submitButton.setAttribute('type', 'submit');
  submitButton.removeAttribute('onclick');
  setTimeout(function(){
    submitButton.click();
    cartAddToCartContainer.innerHtml = '';
  }, 100);
}

$(window).on('load', function() {
    if (window.location.href.indexOf("#review") > -1) {
      setTimeout(function(){ 
        $('.spr-form').addClass("displayform");
      }, 5000);
    }
  });
  $(document.body).on('click', '.spr-summary-actions-newreview', function(e){ 
    $('.spr-form').removeClass("displayform");
  });
 
if ($(window).width() < 797){
  $('.productImgSlider-nav').hide();
}
else{
  $('.productImgSlider-nav').show();
}

// Will trigger selectric() function only if it's lib included
$(function() {
  $('.selectric').selectric({
    disableOnMobile: false,
    nativeOnMobile: false
  });
});

$(document).ready(function(){

  $('.selectric-items .selectric-scroll ul li').each(function(){

    var index = $(this).data('index');

    $(this).attr('data-swatch', $('.selectric-hide-select select option:eq('+index+')').data('swatch'));
    $(this).attr('data-variant', $('.selectric-hide-select select option:eq('+index+')').val());
    $(this).prepend('<span class="swatch-select" style="background-color: '+$(this).data('swatch')+'"></span>');

  });

  $('.selectric-items .selectric-scroll ul li').on('click', function(){
    $('.selectric').find('.label').html($(this).html());
    $('.selectric-hide-select select option[value="'+$(this).data('variant')+'"]').prop('selected', true);
    $('.selectric-hide-select select').trigger('change');
    $('.add-to-cart').attr('data-variant', $(this).data('variant'));

    $('.splide__slide input').each(function(){
      if ($(this).data('variant') == $('.selectric-items .selectric-scroll ul li.selected').data('variant')){
        $(this).trigger('click');
      }
    });
        
  });

  $('.splide__slide input').on('click', function(){
    $(this).addClass('selected');
    $('.splide__slide input').not($(this)).removeClass('selected');
  });
  
  $('.splide__slide input').on('change', function(){
  $('.selectric-items .selectric-scroll ul li').each(function(){
    if ($(this).data('variant') == $('.splide__slide input.selected').data('variant')){
      $(this).trigger('click');
    }
  });
  } );

  // on click .selectric .button, toggle class .is-opened
  $(document).on('mouseup', '.wrapper-flex', function(e){
    $(this).find('.selectric .button').toggleClass('is-opened');
  });

  // if the .selectic-wrapper doesn't have class .selectric-open, remove .is-opened from .selectric .button

});

// if the window width is less than 797px, move the .wrapper-flex before .swatch.swatch--circle.clearfix
if ($(window).width() < 797){
  $('.wrapper-flex').insertBefore('.swatch.swatch--circle.clearfix');
  // move the custom-button after .swatch.swatch--circle.clearfix
  $('.custom-button').insertAfter('.swatch.swatch--circle.clearfix');

  //total number of element
  var n_t = $('.j-swatches-carousel .splide__slide').length;
  //full width of element with margin
  var w = $('.j-swatches-carousel .splide__slide').outerWidth(true);
  //width of container without padding
  var w_c = $('.j-swatches-carousel .splide__list').width();
  //nb element per row
  var nb = Math.min(parseInt(w_c / w),n_t);
  console.log(nb);

  window.addEventListener('resize', function(event){
    //only the width of container will change
    w_c = $('.j-swatches-carousel .splide__list').width();
    nb = Math.min(parseInt(w_c / w),n_t);
    console.log(nb);

  });

  $('.j-swatches-carousel .splide__list li').each(function(index){
    
    if (nb - 1 == index){
      $(this).before('<li class="splide__slide toggle_btn"></li>');
    }

    // hide all elements after the toggle_btn element
    if (nb - 1 <= index){
      $(this).hide();
    }

  });

      // on click on the toggle_btn element, show all elements after the toggle_btn element
  $('.toggle_btn').on('click', function(){
    // toggle the class .is-active on the toggle_btn element
    $(this).toggleClass('is-active');
    $(this).nextAll().slideToggle();
  });

}
  // if the url contains shadefinder=true and variant id, select the swatch with matching data-variant attribute value
  if (window.location.href.indexOf('shadefinder=true') > -1) {
    // get variant id from the url by splitting the url at the ? and taking the second part before next &
    var variant_id = window.location.href.split('?')[1].split('&')[0];
    // remove variant= from the variant_id
    variant_id = variant_id.replace('variant=', '');
    var swatch = document.querySelector('[data-variant="' + variant_id + '"]');
    if (swatch) {
      swatch.click();
      // loop through if .selectric-items .selectric-scroll ul li has matching data-variant attribute value with the ?variant=, trigger click on page load
      $('.selectric-items .selectric-scroll ul li').each(function(){
        if ($(this).data('variant') == variant_id){
          $(this).trigger('click');
        }
      }
      );

    }
  }

$(document).ready(function(){

  $('.featured-collection .collection-links ul li:first-child').addClass('active-link');
  var collection = $('.collection-links ul li.active-link').data('collection');


  $('.featured-collection .collection-btn').each(function(){
    if ($(this).data('collection') != collection){
      $(this).hide();
    } else {
      $(this).show();
  } }); 

  $('.featured-collection .splide').each(function(){
    if ($(this).data('collection') != collection){
      $(this).hide();
    }
  });

  // collection links on click event
  $('.collection-links ul li').on('click', function(){
    $(this).addClass('active-link');
    $(this).siblings().removeClass('active-link');
    var collection = $('.collection-links ul li.active-link').data('collection');
    console.log(collection);

    $('.featured-collection .splide').each(function(){
      if ($(this).data('collection') != collection){
        $(this).hide();
      } else {
        $(this).show();
      }
    });

    $('.featured-collection .collection-btn').each(function(){
      if ($(this).data('collection') != collection){
        $(this).hide();
      } else {
        $(this).show();
    } }); 

  });
});

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);

/********************** custom-currency-code **********************/
$(document).ready(function(){
$('.location_site_link').click(function(){
 $('.location_site_link li').removeClass('active');   
    $(this).addClass('active')
});
  
  $('.footer_location_site_link').click(function(){
 $('.footer_location_site_link li').removeClass('active');   
    $(this).addClass('active')
});
  });
